function n(a, b) {
  if (Array.isArray(a)) {
    for (var c = 0; c < a.length; c++) {
      n(a[c], b);
    }
  } else if ("object" == typeof a && null !== a) {
    for (c in a) {
      "__typename" === c && "string" == typeof a[c] ? b[a[c]] = 0 : n(a[c], b);
    }
  }
  return b;
}

function p(a) {
  return a.kind === Kind.FIELD && "__typename" === a.name.value && !a.alias;
}

function r(a) {
  if (a.selectionSet && !a.selectionSet.selections.some(p)) {
    return _extends({}, a, {
      selectionSet: _extends({}, a.selectionSet, {
        selections: a.selectionSet.selections.concat([ {
          kind: Kind.FIELD,
          name: {
            kind: Kind.NAME,
            value: "__typename"
          }
        } ])
      })
    });
  }
}

function u(a) {
  a = keyDocument(a);
  var b = t.get(a.__key);
  b || ((b = visit(a, {
    Field: r,
    InlineFragment: r
  })).__key = a.__key, t.set(a.__key, b));
  return b;
}

function v(a) {
  return a && "object" == typeof a ? Object.keys(a).reduce((function(b, c) {
    var d = a[c];
    "__typename" === c ? Object.defineProperty(b, "__typename", {
      enumerable: !1,
      value: d
    }) : Array.isArray(d) ? b[c] = d.map(v) : b[c] = d && "object" == typeof d && "__typename" in d ? v(d) : d;
    return b;
  }), {}) : a;
}

function w(a) {
  a.toPromise = function() {
    return toPromise(take(1)(a));
  };
  return a;
}

function x(a, b, c) {
  c || (c = b.context);
  return {
    key: b.key,
    query: b.query,
    variables: b.variables,
    kind: a,
    context: c
  };
}

function y(a, b) {
  return x(a.kind, a, _extends({}, a.context, {
    meta: _extends({}, a.context.meta, b)
  }));
}

function z() {}

function A(a, b, c) {
  var d, e, f;
  for (d = 0; d < c.length; d++) {
    if (c[d].kind === Kind.FRAGMENT_DEFINITION) {
      e = c[d].name.value, f = stringifyDocument(c[d]);
      a.has(e) ? "production" !== process.env.NODE_ENV && a.get(e) !== f && console.warn("[WARNING: Duplicate Fragment] A fragment with name `" + e + "` already exists in this document.\nWhile fragment names may not be unique across your source, each name must be unique per document.") : (a.set(e, f), 
      b.push(c[d]));
    } else {
      b.push(c[d]);
    }
  }
}

function B(a) {
  return "subscription" !== (a = a.kind) && "query" !== a;
}

function C(a) {
  return a.path || a.extensions ? {
    message: a.message,
    path: a.path,
    extensions: a.extensions
  } : a.message;
}

function D(a) {
  return "mutation" !== (a = a.kind) && "query" !== a;
}

function E(a) {
  var b = x(a.kind, a);
  b.query = u(a.query);
  return b;
}

function F(a) {
  return "query" !== a.kind || "cache-only" !== a.context.requestPolicy;
}

function G(a) {
  return y(a, {
    cacheOutcome: "miss"
  });
}

function H(a) {
  return D(a);
}

function I(a) {
  function b(a) {
    var b = a.context.requestPolicy;
    return "query" === a.kind && "network-only" !== b && ("cache-only" === b || k.has(a.key));
  }
  function c(a) {
    var c = k.get(a.key);
    "production" !== process.env.NODE_ENV && q(_extends({}, {
      operation: a
    }, c ? {
      type: "cacheHit",
      message: "The result was successfully retried from the cache"
    } : {
      type: "cacheMiss",
      message: "The result could not be retrieved from the cache"
    }));
    c = _extends({}, c, {
      operation: y(a, {
        cacheOutcome: c ? "hit" : "miss"
      })
    });
    "cache-and-network" === a.context.requestPolicy && (c.stale = !0, J(m, a));
    return c;
  }
  function d(a) {
    return !D(a) && b(a);
  }
  function e(a) {
    function c(a) {
      g.add(a);
    }
    var e, g, l, d = a.operation;
    if (d) {
      e = Object.keys(n(a.data, {})).concat(d.context.additionalTypenames || []);
      if ("mutation" === a.operation.kind) {
        g = new Set;
        "production" !== process.env.NODE_ENV && q({
          type: "cacheInvalidation",
          message: "The following typenames have been invalidated: " + e,
          operation: d,
          data: {
            typenames: e,
            response: a
          },
          source: "cacheExchange"
        });
        for (a = 0; a < e.length; a++) {
          (l = h[l = e[a]] || (h[l] = new Set)).forEach(c);
          l.clear();
        }
        g.forEach((function b(a) {
          k.has(a) && (d = k.get(a).operation, k.delete(a), J(m, d));
        }));
      } else if ("query" === d.kind && a.data) {
        for (k.set(d.key, a), a = 0; a < e.length; a++) {
          (h[l = e[a]] || (h[l] = new Set)).add(d.key);
        }
      }
    }
  }
  function f(a) {
    return !D(a) && !b(a);
  }
  var g = a.forward, m = a.client, q = a.dispatchDebug, k = new Map, h = Object.create(null);
  return function(a) {
    var b = share(a);
    a = map(c)(filter(d)(b));
    b = tap(e)(g(filter(F)(map(G)(merge([ map(E)(filter(f)(b)), filter(H)(b) ])))));
    return merge([ a, b ]);
  };
}

function J(a, b) {
  return a.reexecuteOperation(x(b.kind, b, _extends({}, b.context, {
    requestPolicy: "network-only"
  })));
}

function K(a) {
  return console.log("[Exchange debug]: Completed operation: ", a);
}

function L(a) {
  return console.log("[Exchange debug]: Incoming operation: ", a);
}

function M(a) {
  function b(a) {
    f.delete(a.operation.key);
  }
  function c(a) {
    var c = a.key, b = a.kind;
    if ("teardown" === b) {
      return f.delete(c), !0;
    }
    if ("query" !== b && "subscription" !== b) {
      return !0;
    }
    b = f.has(c);
    f.add(c);
    b && "production" !== process.env.NODE_ENV && e({
      type: "dedup",
      message: "An operation has been deduped.",
      operation: a,
      source: "dedupExchange"
    });
    return !b;
  }
  var d = a.forward, e = a.dispatchDebug, f = new Set;
  return function(a) {
    a = filter(c)(a);
    return tap(b)(d(a));
  };
}

function N(a) {
  return "query" === a.kind || "mutation" === a.kind;
}

function O(a) {
  return "query" !== a.kind && "mutation" !== a.kind;
}

function P(a) {
  var b = a.forward, c = a.dispatchDebug;
  return function(a) {
    var f, d = share(a);
    a = mergeMap((function(a) {
      var b = a.key, e = filter((function(a) {
        return "teardown" === a.kind && a.key === b;
      }))(d), g = makeFetchBody(a), h = makeFetchURL(a, g), l = makeFetchOptions(a, g);
      "production" !== process.env.NODE_ENV && c({
        type: "fetchRequest",
        message: "A fetch request is being executed.",
        operation: a,
        data: {
          url: h,
          fetchOptions: l
        },
        source: "fetchExchange"
      });
      return onPush((function(b) {
        var d = b.data ? void 0 : b.error;
        "production" !== process.env.NODE_ENV && c({
          type: d ? "fetchError" : "fetchSuccess",
          message: "A " + (d ? "failed" : "successful") + " fetch response has been returned.",
          operation: a,
          data: {
            url: h,
            fetchOptions: l,
            value: d || b
          },
          source: "fetchExchange"
        });
      }))(takeUntil(e)(makeFetchSource(a, h, l)));
    }))(filter(N)(d));
    f = b(filter(O)(d));
    return merge([ a, f ]);
  };
}

function Q() {
  return !1;
}

function R(a) {
  function b(a) {
    if ("teardown" !== a.kind && "production" !== process.env.NODE_ENV) {
      var b = 'No exchange has handled operations of kind "' + a.kind + "\". Check whether you've added an exchange responsible for these operations.";
      "production" !== process.env.NODE_ENV && c({
        type: "fallbackCatch",
        message: b,
        operation: a,
        source: "fallbackExchange"
      });
      console.warn(b);
    }
  }
  var c = a.dispatchDebug;
  return function(a) {
    return filter(Q)(tap(b)(a));
  };
}

function T(a) {
  return function(b) {
    var c = b.client, d = b.dispatchDebug;
    return a.reduceRight((function(a, b) {
      return b({
        client: c,
        forward: a,
        dispatchDebug: function(a) {
          "production" !== process.env.NODE_ENV && d(_extends({}, {
            timestamp: Date.now(),
            source: b.name
          }, a));
        }
      });
    }), b.forward);
  };
}

function V(a) {
  var d, e, f, g, m, c = this;
  this.activeOperations = Object.create(null);
  this.queue = [];
  this.createOperationContext = function(a) {
    a || (a = {});
    return _extends({}, {
      url: c.url,
      fetchOptions: c.fetchOptions,
      fetch: c.fetch,
      preferGetMethod: c.preferGetMethod
    }, a, {
      suspense: a.suspense || !1 !== a.suspense && c.suspense,
      requestPolicy: a.requestPolicy || c.requestPolicy
    });
  };
  this.createRequestOperation = function(a, b, d) {
    return x(a, b, c.createOperationContext(d));
  };
  this.executeQuery = function(a, b) {
    a = c.createRequestOperation("query", a, b);
    return c.executeRequestOperation(a);
  };
  this.executeSubscription = function(a, b) {
    a = c.createRequestOperation("subscription", a, b);
    return c.executeRequestOperation(a);
  };
  this.executeMutation = function(a, b) {
    a = c.createRequestOperation("mutation", a, b);
    return c.executeRequestOperation(a);
  };
  if ("production" !== process.env.NODE_ENV && !a.url) {
    throw Error("You are creating an urql-client without a url.");
  }
  d = z;
  if ("production" !== process.env.NODE_ENV) {
    e = (d = makeSubject()).next, f = d.source;
    this.subscribeToDebugTarget = function b(a) {
      return subscribe(a)(f);
    };
    d = e;
  }
  this.url = a.url;
  this.fetchOptions = a.fetchOptions;
  this.fetch = a.fetch;
  this.suspense = !!a.suspense;
  this.requestPolicy = a.requestPolicy || "cache-first";
  this.preferGetMethod = !!a.preferGetMethod;
  this.maskTypename = !!a.maskTypename;
  e = makeSubject();
  g = e.next;
  this.operations$ = e.source;
  m = !1;
  this.dispatchOperation = function(a) {
    m = !0;
    for (a && g(a); a = c.queue.shift(); ) {
      g(a);
    }
    m = !1;
  };
  this.reexecuteOperation = function(a) {
    if ("mutation" === a.kind || 0 < (c.activeOperations[a.key] || 0)) {
      c.queue.push(a), m || Promise.resolve().then(c.dispatchOperation);
    }
  };
  a = T(void 0 !== a.exchanges ? a.exchanges : U);
  this.results$ = share(a({
    client: this,
    dispatchDebug: d,
    forward: R({
      dispatchDebug: d
    })
  })(this.operations$));
  publish(this.results$);
}

function W(a) {
  a.data = v(a.data);
  return a;
}

function createClient(a) {
  return new V(a);
}

function debugExchange(a) {
  var d = a.forward;
  return "production" === process.env.NODE_ENV ? function b(a) {
    return d(a);
  } : function c(a) {
    return tap(K)(d(tap(L)(a)));
  };
}

function errorExchange(a) {
  function b(a) {
    var b = a.error;
    a = a.operation;
    b && c(b, a);
  }
  var c = a.onError;
  return function(a) {
    var c = a.forward;
    return function(a) {
      return tap(b)(c(a));
    };
  };
}

function gql() {
  var a, b, c, d, e, f, g;
  for (a = arguments, b = new Map, c = [], d = [], e = Array.isArray(arguments[0]) ? arguments[0][0] : arguments[0] || "", 
  f = 1; f < arguments.length; f++) {
    (g = a[f]) && g.definitions ? d.push.apply(d, g.definitions) : e += g;
    e += a[0][f];
  }
  A(b, c, keyDocument(e).definitions);
  A(b, c, d);
  return keyDocument({
    kind: Kind.DOCUMENT,
    definitions: c
  });
}

function ssrExchange(a) {
  function b(b) {
    var c = b.client, l = b.forward;
    return function(b) {
      var e = a && "boolean" == typeof a.isClient ? !!a.isClient : !c.suspense, h = share(b);
      b = l(filter(f)(h));
      h = map(g)(filter(m)(h));
      e ? h = tap(d)(h) : b = tap(q)(b);
      return merge([ b, h ]);
    };
  }
  function c(a) {
    return !B(a) && void 0 !== k[a.key];
  }
  function d(a) {
    h.push(a.operation.key);
    1 === h.length && Promise.resolve().then(e);
  }
  function e() {
    for (var a; a = h.shift(); ) {
      delete k[a];
    }
  }
  function f(a) {
    return !c(a);
  }
  function g(a) {
    var b = k[a.key], c = b.error;
    return {
      operation: a,
      data: (b = b.data) ? JSON.parse(b) : void 0,
      extensions: void 0,
      error: c ? new CombinedError({
        networkError: c.networkError ? Error(c.networkError) : void 0,
        graphQLErrors: c.graphQLErrors && c.graphQLErrors.length ? c.graphQLErrors : void 0
      }) : void 0
    };
  }
  function m(a) {
    return c(a);
  }
  function q(a) {
    var c, d, b = a.operation;
    if (!B(b)) {
      c = a.data;
      a = a.error;
      d = {};
      void 0 !== c && (d.data = JSON.stringify(c));
      a && (d.error = {
        graphQLErrors: a.graphQLErrors.map(C)
      }, a.networkError && (d.error.networkError = "" + a.networkError));
      k[b.key] = d;
    }
  }
  var k = {}, h = [];
  b.restoreData = function(a) {
    return _extends(k, a);
  };
  b.extractData = function() {
    return _extends({}, k);
  };
  a && a.initialState && b.restoreData(a.initialState);
  return b;
}

function subscriptionExchange(a) {
  function b(a) {
    return "subscription" === (a = a.kind) || !!d && ("query" === a || "mutation" === a);
  }
  var c = a.forwardSubscription, d = a.enableAllOperations;
  return function(a) {
    function d(a) {
      var b = c({
        key: a.key.toString(36),
        query: print(a.query),
        variables: a.variables,
        context: _extends({}, a.context)
      });
      return make((function(c) {
        function d(b) {
          return f(makeResult(a, b));
        }
        function e(b) {
          return f(makeErrorResult(a, b));
        }
        function h() {
          g || (g = !0, "subscription" === a.kind && m.reexecuteOperation(x("teardown", a, a.context)), 
          l());
        }
        var k, f = c.next, l = c.complete, g = !1;
        Promise.resolve().then((function() {
          g || (k = b.subscribe({
            next: d,
            error: e,
            complete: h
          }));
        }));
        return function() {
          g = !0;
          k && k.unsubscribe();
        };
      }));
    }
    function e(a) {
      return !k(a);
    }
    var m = a.client, q = a.forward, k = b;
    return function(a) {
      var c, b = share(a);
      a = mergeMap((function(a) {
        var c = a.key, e = filter((function(a) {
          return "teardown" === a.kind && a.key === c;
        }))(b);
        return takeUntil(e)(d(a));
      }))(filter(k)(b));
      c = q(filter(e)(b));
      return merge([ a, c ]);
    };
  };
}

var t, S, U;

import { toPromise, take, share, filter, map, tap, merge, mergeMap, takeUntil, make, onPush, makeSubject, publish, onStart, onEnd, switchMap, fromValue, subscribe } from "wonka";

import { k as keyDocument, _ as _extends, s as stringifyDocument, C as CombinedError, m as makeResult, a as makeErrorResult, b as makeFetchBody, c as makeFetchURL, d as makeFetchOptions, e as makeFetchSource, f as createRequest } from "./2c01d8b2.mjs";

import { visit } from "graphql/language/visitor.mjs";

import { Kind } from "graphql/language/kinds.mjs";

import { print } from "graphql/language/printer.mjs";

export { C as CombinedError, f as createRequest, h as getOperationName, a as makeErrorResult, m as makeResult, g as stringifyVariables } from "./2c01d8b2.mjs";

t = new Map;

S = R({
  dispatchDebug: z
});

U = [ M, I, P ];

V.prototype.onOperationStart = function(a) {
  var b = a.key;
  this.activeOperations[b] = (this.activeOperations[b] || 0) + 1;
  this.dispatchOperation(a);
};

V.prototype.onOperationEnd = function(a) {
  var b = a.key, c = this.activeOperations[b] || 0;
  if (0 >= (this.activeOperations[b] = 0 >= c ? 0 : c - 1)) {
    for (b = this.queue.length - 1; 0 <= b; b--) {
      this.queue[b].key === a.key && this.queue.splice(b, 1);
    }
    this.dispatchOperation(x("teardown", a, a.context));
  }
};

V.prototype.executeRequestOperation = function(a) {
  var e, f, c = this, d = filter((function(b) {
    return b.operation.key === a.key;
  }))(this.results$);
  this.maskTypename && (d = map(W)(d));
  if ("mutation" === a.kind) {
    return take(1)(onStart((function b() {
      return c.dispatchOperation(a);
    }))(d));
  }
  e = filter((function(b) {
    return "teardown" === b.kind && b.key === a.key;
  }))(this.operations$), f = filter((function(b) {
    return b.kind === a.kind && b.key === a.key && "cache-only" !== b.context.requestPolicy;
  }))(this.operations$);
  return onEnd((function() {
    c.onOperationEnd(a);
  }))(onStart((function() {
    c.onOperationStart(a);
  }))(switchMap((function(a) {
    return a.stale ? fromValue(a) : merge([ fromValue(a), map((function() {
      return _extends({}, a, {
        stale: !0
      });
    }))(take(1)(f)) ]);
  }))(takeUntil(e)(d))));
};

V.prototype.query = function(a, b, c) {
  c && "boolean" == typeof c.suspense || (c = _extends({}, c, {
    suspense: !1
  }));
  return w(this.executeQuery(createRequest(a, b), c));
};

V.prototype.readQuery = function(a, b, c) {
  var d = null;
  subscribe((function(a) {
    d = a;
  }))(this.executeQuery(createRequest(a, b), c)).unsubscribe();
  return d;
};

V.prototype.subscription = function(a, b, c) {
  return this.executeSubscription(createRequest(a, b), c);
};

V.prototype.mutation = function(a, b, c) {
  return w(this.executeMutation(createRequest(a, b), c));
};

export { V as Client, I as cacheExchange, T as composeExchanges, createClient, debugExchange, M as dedupExchange, U as defaultExchanges, errorExchange, S as fallbackExchangeIO, P as fetchExchange, u as formatDocument, gql, x as makeOperation, v as maskTypename, ssrExchange, subscriptionExchange };
//# sourceMappingURL=urql-core.mjs.map
